import type { CSSInterpolation } from '@emotion/serialize';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef, useEffect } from 'react';

import { useForwardingRef } from '@adflow/frontend/util-common';

import type { InputStatus } from '../Inputs';
import { inputStyles } from '../Inputs';

export interface TextareaProps
	extends InputStatus, ComponentPropsWithoutRef<'textarea'> {
	innerStyles?: CSSInterpolation;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
	function TextareaRender(props, forwardedRef) {
		const { error, archived, disabled, readOnly, innerStyles, ...other } =
			props;

		const ref = useForwardingRef<HTMLTextAreaElement | null>(null, [
			forwardedRef,
		]);

		// Expand height of textarea to remove scroll bar when readOnly
		// Adapted from https://stackoverflow.com/a/24676492
		useEffect(() => {
			const element = ref.current;
			if (readOnly && element) {
				element.style.height = `${element.scrollHeight}px`;
			}
		});

		return (
			<textarea
				ref={ref}
				css={[
					inputStyles.input,
					disabled && inputStyles.inputContainerDisabled,
					archived && inputStyles.inputArchived,
					readOnly && inputStyles.inputReadOnly,

					inputStyles.inputContainer,
					error && inputStyles.inputContainerError,
					disabled && inputStyles.inputContainerDisabled,
					archived && inputStyles.inputContainerArchived,
					readOnly && inputStyles.inputContainerReadOnly,
					{ padding: '0.45rem 0.75rem' },
					innerStyles,
				]}
				disabled={disabled}
				readOnly={readOnly}
				{...other}
			/>
		);
	}
);
